<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="ch00_fm05_ded"></a><a id="page_v"></a><strong><em>To Alexander,<br/>and to Peter and Constantine,<br/>the three “Greats” in my life!</em></strong></p>
<p class="centerv">“The physician must … have two special objects in view<br/>with regard to disease, namely, to do good or to do no harm.”<br/>—Hippocrates, <em>Epidemics,</em> fifth century BC<a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm05_ded.vue?fad1f3f0